import { render } from "./FooterNavTwo.vue?vue&type=template&id=da4e58bc"
import script from "./FooterNavTwo.vue?vue&type=script&lang=js"
export * from "./FooterNavTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__